"use client";

import { useChat } from "@ai-sdk/react";
import { DefaultChatTransport } from "ai";

const transport = new DefaultChatTransport({
  api: "/api/chat",
});

export function useGardenChat() {
  return useChat({ transport });
}
